import { BehaviorSubject } from "rxjs";
import { FileInterface, FileProcessMode } from "../../components/controls/core/base/base-file-upload-box/base-file-upload-box.component";
import { StringPropertyViewModel } from "./string-property-view-model";
import { BaseError } from "../../messages/base-error";
import { PropertyViewModelInitializationInfo } from "../property-view-model-initialization-info";

export class FilePropertyViewModel<TUploadResult = any> extends StringPropertyViewModel {

    /**
     * Testo del bottone per rimuovere il file (default 'Rimuovi file')
     */
    removeFileText$ = new BehaviorSubject<string>('Rimuovi file');

    /**
     * Testo del bottone per aggiungere un file (default 'Aggiungi file')
     */
    addFileText$ = new BehaviorSubject<string>('Aggiungi file');

    /**
     * Indica come deve essere processato il file: Upload | Read (default Upload)
     */
    processMode: FileProcessMode;

    /**
     * Il file selezionato dall'utente (o null se non c'è nessun file selezionato)
     */
    file$ = new BehaviorSubject<File>(null);

    /**
     * Estensione/i accettata/e (default nessuna, cioè tutte accettate)
     */
    accept$ = new BehaviorSubject<string>(''); // es. ".xml,.pdf"

    /**
     * Risultato del processamento del file (upload o lettura, a seconda di processMode)
     */
    processResult$ = new BehaviorSubject<FileInterface<TUploadResult>>(null);

    /**
     * Risultato dell'upload (se processMode = Upload)
     */
    uploadFileFunc?: (file: File) => Promise<FileInterface>;

    /**
     * Funzione di validazione custom del file selezionato. Deve restituire un array di errori (vuoto se non ci sono errori).
     */
    validateFileFunc?: (file: File) => BaseError[];

    constructor(initInfo: PropertyViewModelInitializationInfo) {
        super(initInfo);
        this.additionalCustomValidation = () => {
            if (this.validateFileFunc && this.file$?.value) {
                return this.validateFileFunc(this.file$.value);
            }
            return []
        }
    }
}